import { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import Paths from 'helper/paths';

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  config.baseURL =
    config.baseURL || ((process && process.env.REACT_APP_BASEURL) || 'http://192.168.1.6:5000') + '/api/v1/users';
  return config;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse | null => {
  if (response && (response.status === 200 || response.status === 201)) return response;
  return null;
};

const onResponseError = (error: AxiosError): Promise<AxiosError> => {
  if (error.response?.status === 401) {
    window.location.replace(`${window.location.host}/${Paths.Main.index().name}/${Paths.Login.index().route}`);
  }
  return Promise.reject(error);
};

export function setupInterceptorsTo(axiosInstance: AxiosInstance): AxiosInstance {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
}
